import React from "react";
import { Link } from "react-router-dom";
import "./style.css";
import ceoImage from "../../../assets/ceo-image.webp";

const ExecutiveMessage = () => {
  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <div className="executive-message container">
      <div className="row align-items-center p-0">
        <div className="col-12 col-lg-6">
          <img
            src={ceoImage}
            alt="Analytics illustration"
            className="img-fluid rounded shadow-sm"
          />
        </div>
        <div className="col-12 col-lg-6">
          <div className="d-flex flex-column align-items-start gap-4">
            <h2 className="title fw-bold">CEO's Message</h2>
            <p className="message text-muted">
              At <strong>Educraft Education Network</strong>, our mission is to
              empower students with the right guidance and opportunities to
              achieve their dreams of studying abroad. Since our inception, we
              have remained committed to providing personalized support,
              ensuring that every student embarks on a seamless and successful
              academic journey.
              <br />
              With a team of dedicated professionals and a strong network of
              global institutions, we strive to make international education
              accessible and rewarding. Our goal is to equip students with the
              knowledge, confidence, and resources they need to thrive in a
              global learning environment. <br /> We take pride in being a
              trusted partner in shaping brighter futures and look forward to
              helping more students turn their aspirations into reality.
            </p>
            <div>
              <Link
                to="/about"
                className="btn btn-lg px-4 fw-semibold"
                onClick={scrollHeader}
              >
                ≫ Learn More
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExecutiveMessage;
